import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { useEffect } from "react"
import Advertisements from "../components/advertisements"
import AstonMartinAds from "../components/astonMartinAds"
import { Link } from "gatsby"

import Header from "./header"
import CountryBar from "./countrybar"
import Footer from "./footer"

const LoadScript = () => {
  useEffect(() => {
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.src = "https://epnt.ebay.com/static/epn-smart-tools.js"
    script.async = true
    document.getElementById("script").appendChild(script)
  }, [])

  return (
    <>
      <div id="script" />
      <div className="ebayContainer">
        <div className="ebay">
          <ins
            className="epn-placement"
            data-config-id="5efc984c5da29225ccf11fd5"
          ></ins>
        </div>
      </div>
    </>
  )
}

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <div>
        <div
          style={{
            margin: `0 auto`,
            maxWidth: "100vw",
            position: "relative",
          }}
        >
          <Header siteTitle={data.site.siteMetadata.title} />{" "}
          <main>{children}</main>
          <div>
            <LoadScript />
          </div>
        </div>

        <div className="headings">
          <h1> Search facebook marketplace over 500 miles</h1>
          <h2>
            {" "}
            See what is for sale in the entire world on facebook marketplace{" "}
          </h2>
        </div>
        <CountryBar />

        <AstonMartinAds />
        <div className="notWorking">
          <Link to="/faq"> Website not working? Click here </Link>
          <p></p>
          <p></p>
        </div>
        <Advertisements />
        <div className="repairmode-section">
          <div className="repairmode-content">
            <span className="repairmode-badge">Repair Marketplace</span>
            <h3 className="repairmode-heading">
              <a 
                href="https://repairmode.com" 
                target="_blank" 
                rel="noopener"
                title="RepairMode - Electronics Repair Marketplace for Industrial Equipment"
              >
                RepairMode Electronics Repair Network
              </a>
            </h3>
            <p className="repairmode-description">
              <a 
                href="https://repairmode.com" 
                target="_blank" 
                rel="noopener"
                title="RepairMode - Connect with Specialized Repair Technicians"
                className="repairmode-inline-link"
              >
                RepairMode
              </a> is a distributed-technician repair marketplace connecting factories, fleets, and resellers with specialized electronics repair technicians. Snap a photo of your failed industrial equipment, compare repair bids from qualified technicians, and get it back fully operational.
            </p>
            <div className="repairmode-features">
              <div className="repairmode-feature">
                <span className="repairmode-feature-icon">📸</span>
                <span>Photo-Based Repair Quotes</span>
              </div>
              <div className="repairmode-feature">
                <span className="repairmode-feature-icon">🔧</span>
                <span>Specialized Technician Network</span>
              </div>
              <div className="repairmode-feature">
                <span className="repairmode-feature-icon">⚡</span>
                <span>Fast Turnaround Times</span>
              </div>
            </div>
            <a 
              href="https://repairmode.com" 
              target="_blank" 
              rel="noopener" 
              className="repairmode-cta"
              title="Get Electronics Repair Quotes from RepairMode"
            >
              Get Repair Quotes
              <span className="repairmode-arrow">→</span>
            </a>
            <div className="repairmode-url-display">
              <a 
                href="https://repairmode.com" 
                target="_blank" 
                rel="noopener"
                title="Visit RepairMode.com"
              >
                RepairMode.com
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
